<div class="right-panel h-100 text-grey">
  <div class="d-flex flex-column h-100">
    <div class="actionBar">
      <div class="flex-grow-1 h-100">
        <input class="search w-100" type="text" placeholder="Search" [formControl]="filterText" />
      </div>

      <button *ngIf="isMonitor == false" class="actionBtn" (click)="addBulkNode()" placement="top auto" container="body"
        triggers="hover" ngbTooltip="Import Node Configs">
        <span><i class="bi bi-file-earmark-arrow-up"></i></span>
      </button>

      <button *ngIf="isMonitor == false" (click)="addNewNode()" type="button" class="actionBtn" triggers="hover" ngbTooltip="Add New Node Configuration">
        <span class="bi bi-plus-lg"></span>
      </button>
    </div>
    <div class="right-side w-100">
      <div class="w-100">
        <div class="jobs">
          <table class="table table-hover table-condensed " cellspacing="0" dynamicPagination [rowHeight]="32" [offsetHeight]="200" [paginationInstance]="config">
            <thead>
              <tr class="jobHeadRow" style="color: white; background-color: var(--s-primary-color);">
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">#</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">Config Code</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">HpcConfigId</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">Infrastructure Provider</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">CPU Cores</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">HPC Units</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">Disk</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">Description</a>
                </th>
                <th scope="col" resizable>
                  <a style="color: White; text-decoration: none; cursor: default">GPU Description</a>
                </th>
                <th *ngIf="isMonitor == false" resizable>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr class="jobRow"
                *ngFor="let c of filteredConfigs | paginate: { itemsPerPage: config.itemsPerPage, currentPage: config.currentPage }; let i = index">
                <td scope="row">{{ (config.currentPage - 1) * config.itemsPerPage + (i + 1) }}</td>
                <td #instanceCodeCell style="cursor: pointer; color: var(--s-primary-color);" title="{{ c.instanceCode }}">
                  {{ c.instanceCode | shortenString : (instanceCodeCell.offsetWidth || 200) }}
                </td>
                <td>
                  {{ c.hpcConfigId }}
                </td>
                <td>
                  {{ c.cloudProvider }}
                </td>
                <td title="{{ c.numOfSockets + ' Sockets : ' + c.coresPerSocket + ' Cores/Socket : ' + c.threadsPerCore + ' Threads/Core' }}">
                  {{ c.hpcUnits }} ({{ c.numOfSockets }}:{{ c.coresPerSocket }}:{{ c.threadsPerCore }})
                </td>
                <td>
                  {{ c.cpuCores }}
                </td>
                <td>
                  {{ c.hddType +", "+ c.hddSize+" GB" }}
                </td>
                <td>
                  {{ c.cpuType + ", " + c.cpuCores + " Cores,"+ " " + c.ramSize+ " GB RAM" }}
                </td>
                <td>
                  {{ c.noOfGPU + " GPUs, " + c.gpuMemorySize + " Memory, " + c.gpuModel + " Model"}}
                </td>
                <td *ngIf="isMonitor == false" class="controlActions">
                  <span class="bi bi-pencil-square"
                    (click)="updateNodeConfiguration(c.cpuCores, c.cpuType, c.hddSize, c.ramSize, c.hddType, c.cloudProvider,
                                  c.numOfSockets, c.coresPerSocket, c.threadsPerCore, c.noOfGPU, c.gpuMemorySize, c.gpuModel, c.isRdmaSupported, c.hpcConfigId, c.instanceCode, c.hpcUnits)"
                    title="Edit Node Configuration"></span>
                  <span class="bi bi-trash text-danger" (click)="deleteNodeConfiguration(c.hpcConfigId)"
                    title="Delete Node Configuration"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination-controls *ngIf="configs" class="my-pagination" (pageChange)="config.currentPage = $event" (pageBoundsCorrection)="config.currentPage = $event">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
